import React from "react";
import { Drawer, Layout } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import DashboardSelectBusiness from "./DashboardSelectBusiness";
import DashboardMenu from "../../../common/DashboardMenu";
import { dashboardMenu } from "../data/dashboardMenuItems";
import logo from "../../../images/bizzll-logo.png";
import logoSmall from "../../../images/bizzll-icon.png";

const { Sider } = Layout;

export default function DashboardSidebar({
  baseURL, collapsed, setCollapsed, isMobile, mobileMenuOpen, onClose,
}) {
  const isCollapsed = !isMobile && collapsed;
  const navigation = (
    <nav id="business-dashboard-navigation" aria-label="Business dashboard">
      <DashboardSelectBusiness collapsed={isCollapsed} />
      <DashboardMenu
        baseURL={baseURL}
        dashboardMenu={dashboardMenu}
        mode="inline"
        inlineCollapsed={isCollapsed}
        onNavigate={isMobile ? onClose : undefined}
      />
    </nav>
  );

  if (isMobile) {
    return (
      <Drawer
        title="Business Dashboard"
        placement="left"
        width="min(320px, 90vw)"
        open={mobileMenuOpen}
        onClose={onClose}
        className="business-navigation-drawer"
      >
        {navigation}
      </Drawer>
    );
  }

  return (
    <Sider
      collapsed={collapsed}
      trigger={null}
      width={280}
      collapsedWidth={80}
      className="dashboard-sidebar business-navigation-sidebar"
    >
      <Link className="business-navigation-brand" to={baseURL} aria-label="Business dashboard home">
        <img src={collapsed ? logoSmall : logo} alt="Bizzll" />
      </Link>
      <div className="business-navigation-scroll">{navigation}</div>
      <button
        type="button"
        className="business-navigation-collapse"
        aria-label={collapsed ? "Expand business menu" : "Collapse business menu"}
        aria-expanded={!collapsed}
        aria-controls="business-dashboard-navigation"
        onClick={() => setCollapsed(!collapsed)}
      >
        <FontAwesomeIcon icon={collapsed ? faChevronRight : faChevronLeft} />
        {!collapsed && <span>Collapse menu</span>}
      </button>
    </Sider>
  );
}
